import {clearNumber, formatName} from "../functions";

function formatUser(user) {
  const result = {}

  Object.entries(user).forEach(([key,value])=>{
    switch (key) {
      case 'cellphone':
        result.celular = clearNumber(value);
        break;
      case 'active':
        result.ativo = value
        break
      case 'name':
        result.nome = formatName(value.trim())
        break
      case 'profile':
        result.perfil = value
        break
    }
  })
  return result
}

function formatCellphone(cellphone) {
  return clearNumber(cellphone)
}

export const formatTemplateData = {
  formatUser: (user) => formatUser(user),
  formatCellphone: (cellphone) => formatCellphone(cellphone),
  formatCellphones: (cellphones) => cellphones.map(formatCellphone),
}
